// =============================================================
// IMPORTS
// =============================================================

import("./modules/ccm19.module.js").then((module) => {
  module.init();
});

// =============================================================
// MODULES
// - Lazy loaded modules which are imported when needed
// =============================================================

if (document.querySelector(".flyout-menu")) {
  import("./modules/flyout.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".header")) {
  import("./modules/header.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".lightbox")) {
  import("./modules/magnificPopup.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".modal")) {
  import("./modules/modal.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".panel")) {
  import("./modules/panel.module.js").then((module) => {
    module.init();
  });
}

if (document.getElementById("stickyButton")) {
  import("./modules/stickyButton.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".read-more-marker")) {
  import("./modules/readMoreMarker.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container.swiper-container--1")) {
  import("./modules/swiper1.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container.swiper-container--2")) {
  import("./modules/swiper2.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container.swiper-container--3")) {
  import("./modules/swiper3.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container.swiper-team")) {
  import("./modules/swiperTeam.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_treatment_search")) {
  import("./modules/treatmentSearch.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".js-player")) {
  import("./modules/asVideo.module.js").then((module) => {
    module.init();
  });
}

// =============================================================
// OTHER
// =============================================================
// const updateHeaderHeight = () => {
//   let headerHeight = document.querySelector("header").offsetHeight;
//   document.querySelector("main").style.marginTop = headerHeight + "px";
// };
// updateHeaderHeight();

// =============================================================
// WHEN COMPLETE
// functions which are called when the page is fully loaded
// =============================================================
// let attempts = 0;
// const whenComplete = () => {
//   if (++attempts > 30) return;
//   if (document.readyState === "complete") {
//     window.addEventListener("resize", function (e) {
//       updateHeaderHeight();
//     });
//   } else {
//     setTimeout(() => whenComplete(), 400);
//   }
// };
// whenComplete();

// =============================================================
// STYLES COMPLETE
// Removes styles_essential when general styles are loaded
// =============================================================
// let styleAttempts = 0;
// const stylesComplete = () => {
//   if (++styleAttempts > 30) return;
//   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
//     document.querySelector("#sess").remove();
//   } else {
//     setTimeout(() => stylesComplete(), 300);
//   }
// };
// stylesComplete();
